import React, { useEffect, useState } from 'react';
import {
    Row, Col, Button, Card, Input, Select, Modal
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import './style.css';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import { useLocation, useNavigate } from 'react-router-dom';
import { ondemandHealthRecordRequest, ondemandListHealthRecordRequest } from './Actions';
import { selectLoading, selectOndemandHealthRecordList, selectUploadSuccessData } from './Selectors';
import { BodyTextHeadingSmall, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;

const HealthRecUploadOndemand = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const recordTypes = useSelector(selectOndemandHealthRecordList);
    const requesting = useSelector(selectLoading);
    const uploadSuccess = useSelector(selectUploadSuccessData);

    const {state} = useLocation();

    const [file, setFile] = useState(null);
    const [selectValue, setSelectValue] = useState(null);    

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    

    useEffect(() => {
        dispatch(ondemandListHealthRecordRequest());
    }, []);

    if(uploadSuccess) {
        navigate(('/newtimeslot'),{state});
    }

    const onHandleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && (
            selectedFile.type === 'image/jpeg' ||
      selectedFile.type === 'image/png' ||
      selectedFile.type === 'application/pdf')) {
            setFile(selectedFile);
        }
    };

    const handleChange = (value) => {
        setSelectValue(value);
    };

    const handleSave = () => {
        
        if (selectValue && file) {
            // dispatch({
            //     type: HEALTH_REC_UPLOAD_ONDEMAND,
            //     payload: { file, selectValue }
            // });
            const payload = {
                selectValue,
                file        
            };
            dispatch(ondemandHealthRecordRequest(payload));
        } else {
            Modal.warning({
                title: 'Please select all fields',
            });
        }
    };

    const contentOptions = recordTypes?.map(item => (
        <Option key={item.id} value={item.id}>
            {item.healthRecType}
        </Option>
    ));

    return (
        <Content>
            <Row justify="center" style={{ marginTop: '10px' }}>
                <Col
                    xs={{ span: 22 }}
                    md={{ span: 22 }}
                    lg={{ span: 16 }}
                    xl={{ span: 16 }}
                    xxl={{ span: 12 }}
                >
                    <Card style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)', borderRadius: '4px', marginBottom : '10px' }}>
                        <div>
                            <div style={{ marginBottom: '10px' }}>
                                <BodyTextHeadingSmall text = {langdata.SelectTypeOfRecord ? langdata.SelectTypeOfRecord : 'Select Type Of Record'} />
                                <Select
                                    style={{ width: '100%' }}
                                    onChange={handleChange}
                                    placeholder={langdata.PleaseSelectHealthRecordType ? langdata.PleaseSelectHealthRecordType : 'Please Select Health Record Type'}
                                >
                                    {contentOptions}
                                </Select>
                            </div>
                            <BodyTextHeadingSmall text = {langdata.ChooseFile ? langdata.ChooseFile : 'Choose File'} />
                            <Input
                                type="file"
                                name="file"
                                accept="image/*,application/pdf"
                                onChange={onHandleFileChange}
                                style={{ paddingBottom: '6%' }}
                            />
                            <Button
                                style={{ marginRight: '8px', marginTop: '20px' }}
                                onClick={() => window.history.back()}
                            >
                                <ButtonText text = {langdata.Cancel ? langdata.Cancel : 'Cancel'} color = '#000000'/>
                            </Button>
                            <Button
                                type="primary"
                                style={{ marginTop: '20px' }}
                                onClick={handleSave}
                            >
                                <ButtonText text = {langdata.Save ? langdata.Save : 'Save'} />
                            </Button>
                        </div>
                    </Card>
                </Col>
            </Row>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};

export default HealthRecUploadOndemand;
